import { render, staticRenderFns } from "./allot-belonger.vue?vue&type=template&id=a4e4f046&scoped=true&"
import script from "./allot-belonger.vue?vue&type=script&lang=js&"
export * from "./allot-belonger.vue?vue&type=script&lang=js&"
import style0 from "./allot-belonger.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=a4e4f046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e4f046",
  null
  
)

component.options.__file = "allot-belonger.vue"
export default component.exports